import mockdata from '../mockdata'

export const CLEAR = 'ui-settings/projects/CLEAR'
export const LOAD = 'ui-settings/projects/LOAD'
export const SET = 'ui-settings/projects/SET'
export const ADD = 'ui-settings/projects/ADD'
export const UPDATE = 'ui-settings/projects/UPDATE'

export const defaultState = {
  list: [],
  fetched: false,
  fetching: false,
  count: 0,
  total: 0,
  pages: 0
}

export default function reducer (state = defaultState, action = {}) {
  const newState = { ...state }
  switch (action.type) {
    case CLEAR:
      return {
        ...defaultState
      }

    case LOAD:
      return {
        ...state,
        fetched: false,
        fetching: true
      }

    case SET:
      return {
        ...state,
        fetched: true,
        fetching: false,
        list: action.payload,
        count: action.payload.length,
        total: action.payload.length,
        pages: 1
      }

    case ADD:
      newState.list.push(action.payload)
      newState.count += 1
      newState.total += 1
      newState.fetched = true
      newState.fetching = false
      return newState

    case UPDATE:
      newState.list = Array.prototype.slice.call(state.list).map(item => {
        if (item.id === action.payload.id) {
          return action.payload
        }
        return item
      })
      return newState

    default:
      return state
  }
}

export function clearProjects () {
  return {
    type: CLEAR
  }
}

export function resetProjects () {
  return dispatch => {
    dispatch(clearProjects())
    return dispatch(loadProjects())
  }
}

export function createProject (name, customer) {
  return (dispatch, getState, api) => {
    dispatch({ type: LOAD })
    return api
      .projects
      .create({ name, customer })
      .then(created => {
        console.log(`Created new project: ${JSON.stringify(created, null, 2)}`)
        dispatch({ type: ADD, payload: created })
        return created
      })
      .catch(err => {
        console.error(`Error creating project: ${err.message}`)
      })
  }
}

export function updateProject (id, data) {
  return (dispatch, getState, api) => {
    console.log(`[updateProject] ${id}`, data)
    return api
      .projects
      .update(id, data)
      .then(updated => {
        if (updated && typeof updated === 'object') {
          updated = [updated]
        }

        if (!Array.isArray(updated) || updated.length === 0) {
          throw new Error(`No projects were updated for id: ${id} (${JSON.stringify(updated)})`)
        }

        updated = updated[0]
        dispatch(loadProjects())
        return updated
      })
      .catch(err => {
        console.error(`Error updating project: ${err.message}`)
      })
  }
}

export function setMaintenanceMode (project, maintenanceMode = false) {
  return (dispatch) => dispatch(updateProject(project.id, {
    ...project,
    customer: project.customer.id,
    settings: {
      ...project.settings,
      basicSettings: {
        ...project.settings.basicSettings,
        maintenanceMode
      },
    }
  }))
}

export function setProjectStatus (id, status = 'hidden') {
  return (dispatch) => dispatch(updateProject(id, { status }))
}

export function copyToBeta (id) {
  return (dispatch, getState, api) => {
    return api
      .projects
      .move(id, 'beta')
      .then(result => {
        dispatch(loadProjects())
        return result
      })
      .catch(err => {
        console.error(`Error moving project to beta: ${err.message}`)
        console.error(err.stack)
      })
  }
}

export function setLive (id) {
  return (dispatch, getState, api) => {
    return api
      .projects
      .move(id, 'production')
      .then(result => {
        dispatch(loadProjects())
        return result
      })
      .catch(err => {
        console.error(`Error moving project to production: ${err.message}`)
      })
  }
}

export function loadProjects () {
  return (dispatch, getState, api) => {
    dispatch({ type: LOAD })

    return api
      .projects
      .get()
      .then(payload => {
        dispatch({ type: SET, payload })
        return payload
      })
      .catch(err => {
        console.error(`Error fetching projects: ${err.message}`)
        dispatch(clearProjects())
      })
  }
}



// WEBPACK FOOTER //
// ./ducks/projects.js